//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { IList } from "linq-collections";
import { InventoryEventType } from "./custom-models";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface ListResponseWithTotalCount<T> {
    data: IList<T>;
    totalCount: number;
}

export interface CarDataDto {
    id: string;
    owner: UserSelectDto;
    status: VehicleStatus;
    make: MakeSelectDto;
    model: ModelDataDto;
    usesComplexModel: boolean;
    carModel: CarModelDto;
    subModel: SubModelDto;
    engineVariant: EngineVariantDto;
    countryCode: string;
    licensePlate: string;
    year: number;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    type: VehicleType;
    engineNumber: string;
    summerTireSize: string;
    winterTireSize: string;
    lastAppointment: Date | null;
    lastAppointmentMileage: string;
    registrationValidUntil: Date | null;
    registrationNumber: string;
    registrationCardNumber: string;
    insuranceValidUntil: Date | null;
    insuranceAmount: number | null;
    insuranceNumber: string;
    cascoValidUntil: Date | null;
    cascoAmount: number | null;
    cascoNumber: string;
    entryIntoService: Date | null;
    color: string;
    isDefault: boolean;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    deliveryLongitude: number;
    deliveryLatitude: number;
    isFleetCar: boolean;
    displayNotification: boolean;
    picture: string;
    unreadCommentCount: number;
    activeWorksheetIds: string[];
    requestNewDate: boolean;
    isParking: boolean;
    hasParkingTicket: boolean;
    hasUploadedImage: boolean;
    parkingStartTime: Date | null;
    fleetParking: boolean;
    fleetVignette: boolean;
    fleetServiceable: boolean;
    sortingDate: Date | null;
}

export interface UserSelectDto {
    id: string;
    name: string;
    eMail: string;
    phone: string;
}

export enum VehicleStatus {
    Garage = 0,
    AppointmentReserved = 1,
    AppointmentConfirmed = 2,
    PickingUp = 3,
    WaitingRepair = 4,
    WaitingConfirmation = 5,
    UnderRepair = 6,
    WaitingPayment = 7,
    Returning = 8,
}

export interface MakeSelectDto {
    id: string;
    name: string;
}

export interface ModelDataDto {
    id: string;
    makeId: string;
    name: string;
}

export enum VehicleFuelType {
    Gasoline = 0,
    Diesel = 1,
    Hybrid = 2,
    Electronic = 3,
    Gas = 4,
    PetrolCNG = 5,
    PetrolLPG = 6,
    PetrolEthanol = 7,
    FullHybrid = 8,
    MildHybrid = 9,
    PlugInHybrid = 10,
}

export interface CarFilter {
    searchString: string;
    status: VehicleStatus | null;
    makeName: string;
    modelName: string;
    licensePlate: string;
    registrationValidUntil: Date | null;
    ownerId: string | null;
    fleetManagerId: string | null;
}

export interface CarImageDto {
    image: string;
}

export interface CarListDto {
    id: string;
    status: VehicleStatus;
    make: MakeSelectDto;
    model: ModelDataDto;
    usesComplexModel: boolean;
    carModel: CarModelDto;
    subModel: SubModelDto;
    engineVariant: EngineVariantDto;
    countryCode: string;
    licensePlate: string;
    year: number;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    type: VehicleType;
    engineNumber: string;
    registrationValidUntil: Date | null;
    lastAppointment: Date | null;
    lastAppointmentMileage: string;
    isDefault: boolean;
    isFleetCar: boolean;
    fleetServiceable: boolean;
    displayNotification: boolean;
    unreadCommentCount: number;
    requestNewDate: boolean;
    isParking: boolean;
    hasParkingTicket: boolean;
    hasUploadedImage: boolean;
    parkingStartTime: Date | null;
    sortingDate: Date | null;
}

export enum VehicleType {
    Car = 0,
    Bus = 1,
    Motorcycle = 2,
    Van = 3,
    Truck = 4,
    Trailer = 5,
}

export interface CarSelectDto {
    id: string;
    status: VehicleStatus;
    make: MakeSelectDto;
    model: ModelDataDto;
    usesComplexModel: boolean;
    carModel: CarModelDto;
    subModel: SubModelDto;
    engineVariant: EngineVariantDto;
    licensePlate: string;
    year: number;
    picture: string;
}

export interface FleetCarDataDto extends CarDataDto {
    worksheets: WorksheetListDto[];
}

export interface WorksheetListDto {
    id: string;
    documentNumber: string;
    status: WorksheetStatus;
    serviceCar: ServiceCarSelectDto;
    mileage: number | null;
    firstAppointmentDate: Date | null;
    arrivalDate: Date | null;
    completionDate: Date | null;
    finishedDate: Date | null;
    totalPrice: number;
    assignedUserNames: string[];
    displayManagerNotification: boolean;
    applicationAppointment: boolean;
}

export enum WorksheetStatus {
    AppointmentReserved = 0,
    AppointmentConfirmed = 1,
    NeedsPickUp = 2,
    PickingUpVehicle = 3,
    VehiclePickedUp = 4,
    DeliveringVehicle = 5,
    VehicleArrived = 6,
    UnderReview = 7,
    WaitingWarehousePricing = 8,
    WaitingManagerPricing = 9,
    WaitingConfirmation = 10,
    WaitingRepairParts = 11,
    WaitingRepair = 12,
    UnderRepair = 13,
    WaitingCompletion = 14,
    WaitingPayment = 15,
    NeedsReturning = 16,
    ReturningVehicle = 17,
    VehicleReturned = 18,
    Finished = 19,
    Cancelled = 20,
}

export interface ServiceCarSelectDto {
    id: string;
    customerId: string | null;
    customerName: string;
    make: MakeSelectDto;
    model: ModelDataDto;
    usesComplexModel: boolean;
    carModel: CarModelSelectDto;
    subModel: SubModelDto;
    engineVariant: EngineVariantDto;
    licensePlate: string;
    year: number | null;
    picture: string;
}

export interface ModifyCarDto {
    ownerId: string | null;
    status: VehicleStatus;
    makeId: string | null;
    addNewMake: string;
    modelId: string | null;
    addNewModel: string;
    usesComplexModel: boolean;
    carModelId: string | null;
    subModelId: string | null;
    engineVariantId: string | null;
    licensePlate: string;
    year: number;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    type: VehicleType;
    countryCode: string;
    engineNumber: string;
    summerTireSize: string;
    winterTireSize: string;
    lastAppointment: Date | null;
    lastAppointmentMileage: string;
    registrationValidUntil: Date | null;
    registrationNumber: string;
    registrationCardNumber: string;
    insuranceValidUntil: Date | null;
    insuranceAmount: number | null;
    insuranceNumber: string;
    cascoValidUntil: Date | null;
    cascoAmount: number | null;
    cascoNumber: string;
    entryIntoService: Date | null;
    color: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    fleetParking: boolean;
    fleetVignette: boolean;
    fleetServiceable: boolean;
    picture: string;
}

export interface ConfirmRegistrationRequest {
    token: string;
}

export interface FacebookAccessTokenResult {
    access_token: string;
    token_type: string;
}

export interface MakeDataDto {
    id: string;
    name: string;
    models: ModelDataDto[];
    isPopular: boolean;
    hasComplexModels: boolean;
}

export interface RefreshAccessTokenRequest {
    token: string;
    refreshToken: string;
    platform: DevicePlatform;
}

export enum DevicePlatform {
    Android = 0,
    Ios = 1,
    Web = 2,
}

export interface ReorderArgs {
    id: string;
    fromIndex: number;
    toIndex: number;
}

export interface ResetPasswordRequest {
    eMail: string;
}

export interface SendConfirmRegistrationLinkRequest {
    userId: string;
    userType: LoginUserType;
}

export enum LoginUserType {
    User = 0,
    ServiceEmployee = 1,
    FleetManager = 2,
}

export interface AppointmentDataDto {
    id: string;
    worksheet: WorksheetSelectDto;
    worksheetNote: string;
    customer: CustomerSelectDto;
    serviceCar: ServiceCarSelectDto;
    assignedUser: ServiceEmployeeSelectDto;
    facilities: FacilitySelectDto[];
    extraFacilities: ExtraFacilityDataDto[];
    facilityPrices: FacilityPriceDto[];
    status: WorksheetStatus;
    from: Date;
    to: Date;
    description: string;
    name: string;
    eMail: string;
    phone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    make: MakeSelectDto;
    model: ModelDataDto;
    licensePlate: string;
    year: number | null;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    engineNumber: string;
    summerTireSize: string;
    winterTireSize: string;
    registrationValidUntil: Date | null;
    registrationNumber: string;
    registrationCardNumber: string;
}

export interface WorksheetSelectDto {
    id: string;
    documentNumber: string;
    status: WorksheetStatus;
    serviceCar: ServiceCarSelectDto;
}

export interface CustomerSelectDto {
    id: string;
    customerNumber: string;
    name: string;
    eMail: string;
    phone: string;
    hasAppUser: boolean;
}
export interface PartSelectDto {
    id: string;
    partNumber: string;
    name: string;
    purchasePrice: number;
    retailPrice: number;
    vatId: string;
    unitId: string;
    quantity: number;
    margin: number;
    grossValue: number;
}

export interface ServiceEmployeeSelectDto {
    id: string;
    name: string;
    eMail: string;
    phone: string;
    type: ServiceUserType;
}

export enum ServiceUserType {
    Manager = 0,
    Mechanic = 1,
    Warehouse = 2,
    Delivery = 3,
    FleetManager = 4,
}

export interface FacilitySelectDto {
    id: string;
    name: string;
    description: string;
    type: FacilityTypeSelectDto;
    price: number | null;
    discount: number;
    duration: number;
    extraFacilities: ExtraFacilityDataDto[];
}

export interface FacilityTypeSelectDto {
    id: string;
    name: string;
    category: FacilityTypeCategory;
}

export enum FacilityTypeCategory {
    Repair = 0,
    Hull = 1,
    Washing = 2,
    Management = 3,
}

export interface ExtraFacilityDataDto {
    id: string;
    name: string;
    type: FacilityTypeSelectDto;
    price: number | null;
    discount: number;
    duration: number | null;
}

export interface FacilityPriceDto {
    id: string;
    price: number | null;
}

export interface AppointmentFilter {
    searchString: string;
    serviceCarLicensePlate: string;
    customerName: string;
    worksheetDocumentNumber: string;
    assignedUserName: string;
    status: WorksheetStatus | null;
    facilities: string;
    fromFrom: Date | null;
    fromTo: Date | null;
    toFrom: Date | null;
    toTo: Date | null;
    from: Date | null;
    to: Date | null;
    onlyAppointments: boolean | null;
    assignedUserId: string | null;
    fleetManagerId: string | null;
}

export interface AppointmentListDto {
    id: string;
    serviceId: string;
    worksheetId: string | null;
    worksheetDocumentNumber: string;
    worksheetRequestNewDate: boolean | null;
    worksheetClientRequestNewDate: boolean | null;
    worksheetDeliveryRequested: boolean | null;
    worksheetNote: string;
    customer: CustomerSelectDto;
    serviceCar: ServiceCarSelectDto;
    assignedUserId: string;
    assignedUser: ServiceEmployeeSelectDto;
    status: WorksheetStatus;
    from: Date;
    to: Date;
    description: string;
    applicationAppointment: boolean;
    facilities: FacilityListDto[];
    extraFacilities: ExtraFacilityDataDto[];
}

export interface FacilityListDto {
    id: string;
    name: string;
    description: string;
    type: FacilityTypeSelectDto;
    price: number | null;
    duration: number | null;
    extraFacilities: ExtraFacilityDataDto[];
}

export interface AppointmentSelectDto {
    id: string;
    from: Date;
    to: Date;
    licensePlate: string;
    customerName: string;
}

export interface AppServiceDataDto {
    id: string;
    name: string;
    shortDescription: string;
    description: string;
    eMail: string;
    phone: string;
    zipCode: number;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    taxNumber: string;
    longitude: number;
    latitude: number;
    mondayOpenFrom: Date | null;
    mondayOpenTo: Date | null;
    mondayBreakFrom: Date | null;
    mondayBreakTo: Date | null;
    tuesdayOpenFrom: Date | null;
    tuesdayOpenTo: Date | null;
    tuesdayBreakFrom: Date | null;
    tuesdayBreakTo: Date | null;
    wednesdayOpenFrom: Date | null;
    wednesdayOpenTo: Date | null;
    wednesdayBreakFrom: Date | null;
    wednesdayBreakTo: Date | null;
    thursdayOpenFrom: Date | null;
    thursdayOpenTo: Date | null;
    thursdayBreakFrom: Date | null;
    thursdayBreakTo: Date | null;
    fridayOpenFrom: Date | null;
    fridayOpenTo: Date | null;
    fridayBreakFrom: Date | null;
    fridayBreakTo: Date | null;
    saturdayOpenFrom: Date | null;
    saturdayOpenTo: Date | null;
    saturdayBreakFrom: Date | null;
    saturdayBreakTo: Date | null;
    sundayOpenFrom: Date | null;
    sundayOpenTo: Date | null;
    sundayBreakFrom: Date | null;
    sundayBreakTo: Date | null;
    cover: string;
    icon: string;
    rating: number;
    priceCategory: PriceCategory;
    deliveryEnabled: boolean;
    hourlyFee: number;
    deliveryHourlyFee: number;
    isFavorite: boolean;
    facilities: AppFacilityDataDto[];
}

export enum PriceCategory {
    One = 0,
    Two = 1,
    Three = 2,
}

export interface AppFacilityDataDto {
    id: string;
    name: string;
    description: string;
    type: FacilityTypeSelectDto;
    price: number | null;
    discount: number;
    duration: number;
    picture: string;
    makeCount: number;
    employeeCount: number;
    extraFacilities: ExtraFacilityDataDto[];
    existingExtraFacilities: ExtraFacilityDataDto[];
}

export interface AvailableAppointmentsRequest {
    serviceId: string;
    serviceEmployeeId: string | null;
    date: Date | null;
    facilities: AppointmentFacilityDto[];
}

export interface AppointmentFacilityDto {
    id: string;
    duration: number;
    extraFacilities: AppointmentExtraFacilityDto[];
    existingExtraFacilities: AppointmentExtraFacilityDto[];
}

export interface AppointmentExtraFacilityDto {
    id: string;
    duration: number;
}

export interface AvailableAppointmentsResult {
    appointments: AvailableAppointment[];
}

export interface AvailableAppointment {
    from: Date;
    to: Date;
    duration: number;
    subAppointments: Slot[];
}

export interface Interval {
    from: Date;
    to: Date;
}

export interface Slot extends Interval {
    userId: string;
    facilityId: string;
    duration: number;
}

export interface BookAppointmentRequest {
    serviceId: string;
    requestingUserId: string;
    carId: string;
    appointment: BookAvailableAppointment;
    comment: string;
}

export interface BookAvailableAppointment extends AvailableAppointment {
    subAppointments: BookSlot[];
    deliveryRequested: boolean;
    deliveryAddress: string;
    deliveryPrice: number;
}

export interface BookSlot extends Slot {
    price: number;
    extraFacilities: BookAppointmentExtraFacilityDto[];
    existingExtraFacilities: BookAppointmentExtraFacilityDto[];
}

export interface BookAppointmentExtraFacilityDto {
    id: string;
    price: number;
}

export interface BookServiceAppointmentRequest {
    serviceId: string;
    serviceCarId: string;
    appointment: BookAvailableAppointment;
    comment: string;
}

export interface CalendarFacilityDto {
    id: string;
    name: string;
}

export interface CalendarListDto {
    id: string;
    serviceId: string;
    fleetManagerId: string | null;
    serviceCar: ServiceCarSelectDto;
    assignedUserId: string;
    status: WorksheetStatus;
    from: Date;
    to: Date;
    description: string;
    applicationAppointment: boolean;
    facilities: CalendarFacilityListDto[];
    extraFacilities: ExtraFacilityDataDto[];
    worksheetNote: string;
    worksheetDeliveryRequested: boolean | null;
}

export interface CalendarFacilityListDto {
    id: string;
    name: string;
    description: string;
    type: FacilityTypeSelectDto;
    price: number | null;
    duration: number | null;
    extraFacilities: ExtraFacilityDataDto[];
}

export interface CalendarServicePartnerDto {
    id: string;
    serviceId: string;
    serviceName: string;
    employees: CalendarServicePartnerEmployeeDto[];
    mondayOpenFrom: Date | null;
    mondayOpenTo: Date | null;
    mondayBreakFrom: Date | null;
    mondayBreakTo: Date | null;
    tuesdayOpenFrom: Date | null;
    tuesdayOpenTo: Date | null;
    tuesdayBreakFrom: Date | null;
    tuesdayBreakTo: Date | null;
    wednesdayOpenFrom: Date | null;
    wednesdayOpenTo: Date | null;
    wednesdayBreakFrom: Date | null;
    wednesdayBreakTo: Date | null;
    thursdayOpenFrom: Date | null;
    thursdayOpenTo: Date | null;
    thursdayBreakFrom: Date | null;
    thursdayBreakTo: Date | null;
    fridayOpenFrom: Date | null;
    fridayOpenTo: Date | null;
    fridayBreakFrom: Date | null;
    fridayBreakTo: Date | null;
    saturdayOpenFrom: Date | null;
    saturdayOpenTo: Date | null;
    saturdayBreakFrom: Date | null;
    saturdayBreakTo: Date | null;
    sundayOpenFrom: Date | null;
    sundayOpenTo: Date | null;
    sundayBreakFrom: Date | null;
    sundayBreakTo: Date | null;
}

export interface CalendarServicePartnerEmployeeDto extends ServiceEmployeeSelectDto {
    facilities: CalendarFacilityListDto[];
    mondayOpenFrom: Date | null;
    mondayOpenTo: Date | null;
    mondayBreakFrom: Date | null;
    mondayBreakTo: Date | null;
    tuesdayOpenFrom: Date | null;
    tuesdayOpenTo: Date | null;
    tuesdayBreakFrom: Date | null;
    tuesdayBreakTo: Date | null;
    wednesdayOpenFrom: Date | null;
    wednesdayOpenTo: Date | null;
    wednesdayBreakFrom: Date | null;
    wednesdayBreakTo: Date | null;
    thursdayOpenFrom: Date | null;
    thursdayOpenTo: Date | null;
    thursdayBreakFrom: Date | null;
    thursdayBreakTo: Date | null;
    fridayOpenFrom: Date | null;
    fridayOpenTo: Date | null;
    fridayBreakFrom: Date | null;
    fridayBreakTo: Date | null;
    saturdayOpenFrom: Date | null;
    saturdayOpenTo: Date | null;
    saturdayBreakFrom: Date | null;
    saturdayBreakTo: Date | null;
    sundayOpenFrom: Date | null;
    sundayOpenTo: Date | null;
    sundayBreakFrom: Date | null;
    sundayBreakTo: Date | null;
}

export interface CancelWorksheetRequest {
    cancelType: CancelType;
    cancelMessage: string;
}

export enum CancelType {
    Overloaded = 0,
    Other = 1,
}

export interface CheckAccountSetUpDto {
    isSetUp: boolean;
    payInStore: boolean;
}

export interface CommentDataDto {
    createdDate: Date;
    source: CommentSource;
    target: CommentTarget;
    customerName: string;
    serviceName: string;
    serviceEmployeeName: string;
    isServiceManager: boolean;
    message: string;
}

export enum CommentSource {
    Service = 0,
    Customer = 1,
}

export enum CommentTarget {
    Service = 0,
    Customer = 1,
}

export interface ConfirmWorksheetArgs {
    requestedFaults: string[];
}

export interface CreateAccountLinkDto {
    accountLink: string;
}

export interface CreateLoginLinkDto {
    loginLink: string;
}

export interface CustomerDataDto {
    id: string;
    customerNumber: string;
    name: string;
    eMail: string;
    phone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    taxNumber: string;
    addressFloor: string;
    addressDoor: string;
    hasAppUser: boolean;
}

export interface CustomerFilter {
    id: string | null;
    searchString: string;
    name: string;
    eMail: string;
    phone: string;
}

export interface CustomerListDto {
    id: string;
    customerNumber: string;
    name: string;
    eMail: string;
    phone: string;
    licensePlates: string;
    hasAppUser: boolean;
}

export interface FacilityDataDto {
    id: string;
    name: string;
    description: string;
    type: FacilityTypeSelectDto;
    price: number | null;
    duration: number;
    picture: string;
    makes: MakeSelectDto[];
    extraFacilities: ExtraFacilityDataDto[];
    existingExtraFacilities: FacilitySelectDto[];
    employees: ServiceEmployeeSelectDto[];
    suzukiCode: string;
    suzukiCodeEnabled: boolean;
}

export interface FacilityFilter {
    searchString: string;
    name: string;
    description: string;
    employeeId: string | null;
}

export interface FacilityTypeDataDto {
    id: string;
    name: string;
    category: FacilityTypeCategory;
    facilities: FacilitySelectDto[];
}

export interface FacilityTypeFilter {
    searchString: string;
    name: string;
    category: FacilityTypeCategory | null;
}

export interface FacilityTypeListDto {
    id: string;
    name: string;
    category: FacilityTypeCategory;
}

export interface FaultDataDto {
    id: string;
    faultName: string;
    requested: boolean;
    repairPartName: string;
    repairPartPrice: number;
    repairPartQuantity: number;
    additionalPrice: number;
    discount: number;
    totalPrice: number;
    picture: string;
    createdDate: Date;
    repairParts: FaultRepairPartDataDto[];
}

export interface FaultRepairPartDataDto {
    id: string;
    repairPartName: string;
    repairPartPrice: number;
    repairPartQuantity: number;
    repairPartUnit: string;
    discount: number;
    partId: string;
    part: PartSelectDto;
    margin: number;
    grossValue: number;
}

export interface FleetCustomerDataDto {
    id: string;
    name: string;
    eMail: string;
    phone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    cars: CarSelectDto[];
    worksheets: WorksheetListDto[];
}

export interface FleetCustomerFilter {
    searchString: string;
    name: string;
    eMail: string;
    phone: string;
}

export interface FleetCustomerListDto {
    id: string;
    name: string;
    eMail: string;
    phone: string;
}

export interface FleetManagerSettingDataDto {
    id: string;
    appointmentReservedColor: string;
    appointmentConfirmedColor: string;
    needsPickUpColor: string;
    pickingUpVehicleColor: string;
    vehiclePickedUpColor: string;
    deliveringVehicleColor: string;
    vehicleArrivedColor: string;
    underReviewColor: string;
    waitingWarehousePricingColor: string;
    waitingManagerPricingColor: string;
    waitingConfirmationColor: string;
    waitingRepairPartsColor: string;
    waitingRepairColor: string;
    underRepairColor: string;
    waitingCompletionColor: string;
    waitingPaymentColor: string;
    needsReturningColor: string;
    returningVehicleColor: string;
    vehicleReturnedColor: string;
    finishedColor: string;
    cancelledColor: string;
    appointmentReservedEnabled: boolean;
    appointmentConfirmedEnabled: boolean;
    needsPickUpEnabled: boolean;
    pickingUpVehicleEnabled: boolean;
    vehiclePickedUpEnabled: boolean;
    deliveringVehicleEnabled: boolean;
    vehicleArrivedEnabled: boolean;
    underReviewEnabled: boolean;
    waitingWarehousePricingEnabled: boolean;
    waitingManagerPricingEnabled: boolean;
    waitingConfirmationEnabled: boolean;
    waitingRepairPartsEnabled: boolean;
    waitingRepairEnabled: boolean;
    underRepairEnabled: boolean;
    waitingCompletionEnabled: boolean;
    waitingPaymentEnabled: boolean;
    needsReturningEnabled: boolean;
    returningVehicleEnabled: boolean;
    vehicleReturnedEnabled: boolean;
    finishedEnabled: boolean;
    cancelledEnabled: boolean;
}

export interface HourlyFeeDataDto {
    id: string;
    description: string;
    yearFrom: number;
    yearTo: number;
    make: MakeSelectDto;
    amount: number;
    priority: number;
}

export interface HourlyFeeFilter {}

export interface HourlyFeeListDto {
    id: string;
    description: string;
    yearFrom: number;
    yearTo: number;
    make: MakeSelectDto;
    amount: number;
    priority: number;
}

export interface HourlyFeeSelectDto {
    id: string;
    description: string;
}

export interface ModifyAppointmentDto {
    worksheetId: string | null;
    addNewWorksheet: boolean;
    assignedUserId: string;
    status: WorksheetStatus;
    facilities: FacilitySelectDto[];
    worksheetNote: string;
    from: Date;
    to: Date;
    customerId: string | null;
    addNewCustomer: boolean;
    name: string;
    eMail: string;
    phone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    serviceCarId: string | null;
    addNewServiceCar: boolean;
    makeId: string | null;
    addNewMake: string;
    modelId: string | null;
    addNewModel: string;
    licensePlate: string;
    year: number | null;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    engineNumber: string;
    summerTireSize: string;
    winterTireSize: string;
    registrationValidUntil: Date | null;
    registrationNumber: string;
    registrationCardNumber: string;
}

export interface ModifyCommentDto {
    source: CommentSource;
    target: CommentTarget;
    worksheetId: string | null;
    serviceEmployeeId: string | null;
    isServiceManager: boolean;
    message: string;
}

export interface ModifyCustomerDto {
    customerNumber: string;
    name: string;
    eMail: string;
    taxNumber: string;
    phone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
}

export interface ModifyExtraFacilityDto {
    id: string | null;
    name: string;
    typeId: string | null;
    price: number | null;
    duration: number | null;
}

export interface ModifyFacilityDto {
    name: string;
    description: string;
    typeId: string | null;
    price: number | null;
    duration: number;
    picture: string;
    makes: string[];
    extraFacilities: ModifyExtraFacilityDto[];
    existingExtraFacilities: string[];
    employees: string[];
    suzukiCode: string;
    suzukiCodeEnabled: boolean;
}

export interface ModifyFacilityTypeDto {
    name: string;
    category: FacilityTypeCategory;
    facilities: string[];
}

export interface ModifyFaultDto {
    id: string;
    faultName: string;
    requested: boolean;
    repairPartName: string;
    repairPartPrice: number;
    repairPartQuantity: number;
    additionalPrice: number;
    discount: number;
    totalPrice: number;
    picture: string;
    repairParts: FaultRepairPartDataDto[];
}

export interface ModifyHourlyFeeDto {
    id: string;
    description: string;
    yearFrom: number;
    yearTo: number;
    makeId: string;
    amount: number;
    priority: number;
}

export interface ModifyServiceCarDto {
    customerId: string | null;
    makeId: string | null;
    addNewMake: string;
    modelId: string | null;
    addNewModel: string;
    usesComplexModel: boolean;
    carModelId: string | null;
    subModelId: string | null;
    engineVariantId: string | null;
    licensePlate: string;
    year: number | null;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    engineNumber: string;
    summerTireSize: string;
    winterTireSize: string;
    registrationValidUntil: Date | null;
    registrationNumber: string;
    registrationCardNumber: string;
    billingName: string;
    billingTaxNumber: string;
    billingZipCode: number | null;
    billingCity: string;
    billingStreetName: string;
    billingStreetCategory: string;
    billingStreetNumber: string;
    billingAddressFloor: string;
    billingAddressDoor: string;
    picture: string;
}

export interface ModifyServiceDto {
    name: string;
    shortDescription: string;
    description: string;
    eMail: string;
    phone: string;
    zipCode: number;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    taxNumber: string;
    dealerCode: string;
    mondayOpenFrom: Date | null;
    mondayOpenTo: Date | null;
    mondayBreakFrom: Date | null;
    mondayBreakTo: Date | null;
    tuesdayOpenFrom: Date | null;
    tuesdayOpenTo: Date | null;
    tuesdayBreakFrom: Date | null;
    tuesdayBreakTo: Date | null;
    wednesdayOpenFrom: Date | null;
    wednesdayOpenTo: Date | null;
    wednesdayBreakFrom: Date | null;
    wednesdayBreakTo: Date | null;
    thursdayOpenFrom: Date | null;
    thursdayOpenTo: Date | null;
    thursdayBreakFrom: Date | null;
    thursdayBreakTo: Date | null;
    fridayOpenFrom: Date | null;
    fridayOpenTo: Date | null;
    fridayBreakFrom: Date | null;
    fridayBreakTo: Date | null;
    saturdayOpenFrom: Date | null;
    saturdayOpenTo: Date | null;
    saturdayBreakFrom: Date | null;
    saturdayBreakTo: Date | null;
    sundayOpenFrom: Date | null;
    sundayOpenTo: Date | null;
    sundayBreakFrom: Date | null;
    sundayBreakTo: Date | null;
    picture: string;
    logo: string;
    deliveryEnabled: boolean;
    temporarilyClosed: boolean;
    hourlyFee: number;
    deliveryHourlyFee: number;
    apiKey: string;
    invoiceNumberPrefix: string;
}

export interface ModifyServiceMakesDto {
    hourlyFee: number;
    deliveryHourlyFee: number;
    makes: string[];
}

export interface ModifyServicePartnerDto {
    serviceId: string | null;
    fleetManagerId: string | null;
    acceptedByFleetManager: boolean;
    acceptedByServiceManager: boolean;
}

export interface ModifyPartDto {
    partNumber: string;
    name: string;
    typeId: string;
    groupId: string;
    purchasePrice: number;
    margin: number;
    retailPrice: number;
    shelfLocation: string;
    quantity: number;
    reservedQuantity: number;
    unitId: string;
    minimumStock: number;
    minimumMargin: number;
    vatId: string;
}

export interface ModifySupplierDto {
    name: string;
    address: string;
    phoneNumber: string;
    email: string;
    website: string;
    contactPerson: string;
    taxNumber: string;
    bankAccountNumber: string;
}

export interface ModifyDiscountDto {
    customerId: string;
    discountRate: number;
}

export interface ModifyWorksheetDto {
    status: WorksheetStatus;
    mileage: number | null;
    arrivalDate: Date | null;
    completionDate: Date | null;
    discount: number;
    totalPrice: number;
    note: string;
    deliveryUserId: string | null;
    deliveryRequested: boolean;
    deliveryPrice: number;
    existingAppointmentId: string | null;
    customerId: string | null;
    addNewCustomer: boolean;
    name: string;
    eMail: string;
    phone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    serviceCarId: string | null;
    addNewServiceCar: boolean;
    makeId: string | null;
    addNewMake: string;
    modelId: string | null;
    addNewModel: string;
    licensePlate: string;
    year: number | null;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    engineNumber: string;
    summerTireSize: string;
    winterTireSize: string;
    registrationValidUntil: Date | null;
    registrationNumber: string;
    registrationCardNumber: string;
    faults: ModifyFaultDto[];
    facilities: ModifyAppointmentFacilityDto[];
}

export interface ModifyAppointmentFacilityDto {
    id: string;
    price: number | null;
    discount: number;
    duration: number;
    extraFacilities: ExtraFacilityDataDto[];
}

export interface ServiceCarDataDto {
    id: string;
    customer: CustomerSelectDto;
    make: MakeSelectDto;
    model: ModelDataDto;
    usesComplexModel: boolean;
    carModel: CarModelSelectDto;
    subModel: SubModelDto;
    engineVariant: EngineVariantDto;
    licensePlate: string;
    year: number | null;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    engineNumber: string;
    summerTireSize: string;
    winterTireSize: string;
    registrationValidUntil: Date | null;
    registrationNumber: string;
    registrationCardNumber: string;
    billingName: string;
    billingTaxNumber: string;
    billingZipCode: number | null;
    billingCity: string;
    billingStreetName: string;
    billingStreetCategory: string;
    billingStreetNumber: string;
    billingAddressFloor: string;
    billingAddressDoor: string;
    picture: string;
}

export interface ServiceCarFilter {
    searchString: string;
    makeName: string;
    modelName: string;
    carModelName: string;
    subModelName: string;
    engineVariantName: string;
    engineVariantType: string;
    licensePlate: string;
    year: number | null;
    customerId: string | null;
}

export interface ServiceCarListDto {
    id: string;
    make: MakeSelectDto;
    model: ModelDataDto;
    usesComplexModel: boolean;
    carModel: CarModelSelectDto;
    subModel: SubModelDto;
    engineVariant: EngineVariantDto;
    licensePlate: string;
    year: number | null;
}

export interface ServiceDataDto {
    id: string;
    name: string;
    shortDescription: string;
    description: string;
    eMail: string;
    phone: string;
    zipCode: number;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    taxNumber: string;
    longitude: number;
    latitude: number;
    dealerCode: string;
    mondayOpenFrom: Date | null;
    mondayOpenTo: Date | null;
    mondayBreakFrom: Date | null;
    mondayBreakTo: Date | null;
    tuesdayOpenFrom: Date | null;
    tuesdayOpenTo: Date | null;
    tuesdayBreakFrom: Date | null;
    tuesdayBreakTo: Date | null;
    wednesdayOpenFrom: Date | null;
    wednesdayOpenTo: Date | null;
    wednesdayBreakFrom: Date | null;
    wednesdayBreakTo: Date | null;
    thursdayOpenFrom: Date | null;
    thursdayOpenTo: Date | null;
    thursdayBreakFrom: Date | null;
    thursdayBreakTo: Date | null;
    fridayOpenFrom: Date | null;
    fridayOpenTo: Date | null;
    fridayBreakFrom: Date | null;
    fridayBreakTo: Date | null;
    saturdayOpenFrom: Date | null;
    saturdayOpenTo: Date | null;
    saturdayBreakFrom: Date | null;
    saturdayBreakTo: Date | null;
    sundayOpenFrom: Date | null;
    sundayOpenTo: Date | null;
    sundayBreakFrom: Date | null;
    sundayBreakTo: Date | null;
    picture: string;
    logo: string;
    rating: number;
    priceCategory: PriceCategory;
    hasAccount: boolean;
    stripeSetUp: boolean;
    payInStore: boolean;
    deliveryEnabled: boolean;
    temporarilyClosed: boolean;
    hourlyFee: number;
    deliveryHourlyFee: number;
    apiKey: string;
    invoiceNumberPrefix: string;
}

export interface ServiceDeliveryDataDto {
    serviceLongitude: number;
    serviceLatitude: number;
    deliveryLongitude: number;
    deliveryLatitude: number;
    currentLongitude: number;
    currentLatitude: number;
}

export interface ServiceFilter {
    searchString: string;
    longitudeFrom: number | null;
    longitudeTo: number | null;
    latitudeFrom: number | null;
    latitudeTo: number | null;
    currentLongitude: number | null;
    currentLatitude: number | null;
    rating: number | null;
    priceCategory: PriceCategory | null;
    fleetManagerId: string | null;
}

export interface ServiceMakesDataDto {
    hourlyFee: number;
    deliveryHourlyFee: number;
    makes: MakeSelectDto[];
}

export interface ServicePartnerDataDto {
    id: string;
    service: ServiceDataDto;
    fleetManager: FleetManagerDataDto;
    acceptedByFleetManager: boolean;
    acceptedByServiceManager: boolean;
}

export interface PartDataDto {
    id: string;
    partNumber: string;
    name: string;
    typeId: string;
    type: PartTypeSelectDto;
    groupId: string;
    group: PartGroupSelectDto;
    purchasePrice: number;
    margin: number;
    retailPrice: number;
    grossValue: number;
    shelfLocation: string;
    quantity: number;
    reservedQuantity: number;
    unitId: string;
    unit: PartUnitSelectDto;
    minimumStock: number;
    minimumMargin: number;
    vatId: string;
    vat: VatSelectDto;
}

export interface PartHistoryDataDto {
    id: string;
    partNumber: string;
    name: string;
    typeId: string;
    type: PartTypeSelectDto;
    groupId: string;
    group: PartGroupSelectDto;
    purchasePrice: number;
    margin: number;
    retailPrice: number;
    shelfLocation: string;
    quantity: number;
    reservedQuantity: number;
    unitId: string;
    unit: PartUnitSelectDto;
    minimumStock: number;
    minimumMargin: number;
    vatId: string;
    vat: VatSelectDto;
    inventoryEventItems: InventoryEventItemDataDto[];
}

export interface SupplierDataDto {
    id: string;
    name: string;
    address: string;
    phoneNumber: string;
    email: string;
    website: string;
    contactPerson: string;
    taxNumber: string;
    bankAccountNumber: string;
}

export interface SupplierSelectDto {
    id: string;
    name: string;
    address: string;
    phoneNumber: string;
    email: string;
}

export interface DiscountDataDto {
    id: string;
    customer: CustomerSelectDto;
    discountRate: number;
}

export interface FleetManagerDataDto {
    id: string;
    name: string;
    eMail: string;
    phone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    taxNumber: string;
}

export interface ServicePartnerFilter {
    searchString: string;
    serviceName: string;
    fleetManagerName: string;
    serviceId: string | null;
    fleetManagerId: string | null;
}

export interface PartFilter {
    searchString: string;
    partNumber: string;
    name: string;
    type: string;
    purchasePrice: number;
    retailPrice: number;
    shelfLocation: string;
    quantity: number;
}

export interface SupplierFilter {
    searchString: string;
    name: string;
    address: string;
    phoneNumber: string;
    email: string;
    website: string;
    contactPerson: string;
    taxNumber: string;
    bankAccountNumber: string;
}

export interface DiscountFilter {
    searchString: string;
    customerName: string;
}

export interface ServicePartnerListDto {
    id: string;
    service: ServiceSelectDto;
    fleetManager: ServiceUserSelectDto;
    acceptedByFleetManager: boolean;
    acceptedByServiceManager: boolean;
}

export interface PartListDto {
    id: string;
    partNumber: string;
    name: string;
    type: string;
    group: string;
    purchasePrice: number;
    margin: number;
    retailPrice: number;
    shelfLocation: string;
    quantity: number;
    reservedQuantity: number;
    netValue: number;
    grossValue: number;
    unit: string;
}

export interface SupplierListDto {
    id: string;
    name: string;
    type: string;
    address: string;
    phoneNumber: string;
    email: string;
    website: string;
    contactPerson: string;
    taxNumber: string;
    bankAccountNumber: string;
}

export interface DiscountListDto {
    id: string;
    customerName: string;
    discountRate: number;
}

export interface ServiceSelectDto {
    id: string;
    name: string;
    shortDescription: string;
    eMail: string;
    phone: string;
}

export interface ServiceUserSelectDto {
    id: string;
    name: string;
    eMail: string;
    phone: string;
}

export interface ServiceSettingDataDto {
    id: string;
    appointmentReservedColor: string;
    appointmentConfirmedColor: string;
    needsPickUpColor: string;
    pickingUpVehicleColor: string;
    vehiclePickedUpColor: string;
    deliveringVehicleColor: string;
    vehicleArrivedColor: string;
    underReviewColor: string;
    waitingWarehousePricingColor: string;
    waitingManagerPricingColor: string;
    waitingConfirmationColor: string;
    waitingRepairPartsColor: string;
    waitingRepairColor: string;
    underRepairColor: string;
    waitingCompletionColor: string;
    waitingPaymentColor: string;
    needsReturningColor: string;
    returningVehicleColor: string;
    vehicleReturnedColor: string;
    finishedColor: string;
    cancelledColor: string;
    appointmentReservedEnabled: boolean;
    appointmentConfirmedEnabled: boolean;
    needsPickUpEnabled: boolean;
    pickingUpVehicleEnabled: boolean;
    vehiclePickedUpEnabled: boolean;
    deliveringVehicleEnabled: boolean;
    vehicleArrivedEnabled: boolean;
    underReviewEnabled: boolean;
    waitingWarehousePricingEnabled: boolean;
    waitingManagerPricingEnabled: boolean;
    waitingConfirmationEnabled: boolean;
    waitingRepairPartsEnabled: boolean;
    waitingRepairEnabled: boolean;
    underRepairEnabled: boolean;
    waitingCompletionEnabled: boolean;
    waitingPaymentEnabled: boolean;
    needsReturningEnabled: boolean;
    returningVehicleEnabled: boolean;
    vehicleReturnedEnabled: boolean;
    finishedEnabled: boolean;
    cancelledEnabled: boolean;
}

export interface UpdateAppointmentRequest {
    serviceId: string;
    worksheetId: string;
    appointment: BookAvailableAppointment;
    requestNewDate: boolean;
}

export interface UpdateFleetManagerSettingDto {
    appointmentReservedColor: string;
    appointmentConfirmedColor: string;
    needsPickUpColor: string;
    pickingUpVehicleColor: string;
    vehiclePickedUpColor: string;
    deliveringVehicleColor: string;
    vehicleArrivedColor: string;
    underReviewColor: string;
    waitingWarehousePricingColor: string;
    waitingManagerPricingColor: string;
    waitingConfirmationColor: string;
    waitingRepairPartsColor: string;
    waitingRepairColor: string;
    underRepairColor: string;
    waitingCompletionColor: string;
    waitingPaymentColor: string;
    needsReturningColor: string;
    returningVehicleColor: string;
    vehicleReturnedColor: string;
    finishedColor: string;
    cancelledColor: string;
    appointmentReservedEnabled: boolean;
    appointmentConfirmedEnabled: boolean;
    needsPickUpEnabled: boolean;
    pickingUpVehicleEnabled: boolean;
    vehiclePickedUpEnabled: boolean;
    deliveringVehicleEnabled: boolean;
    vehicleArrivedEnabled: boolean;
    underReviewEnabled: boolean;
    waitingWarehousePricingEnabled: boolean;
    waitingManagerPricingEnabled: boolean;
    waitingConfirmationEnabled: boolean;
    waitingRepairPartsEnabled: boolean;
    waitingRepairEnabled: boolean;
    underRepairEnabled: boolean;
    waitingCompletionEnabled: boolean;
    waitingPaymentEnabled: boolean;
    needsReturningEnabled: boolean;
    returningVehicleEnabled: boolean;
    vehicleReturnedEnabled: boolean;
    finishedEnabled: boolean;
    cancelledEnabled: boolean;
}

export interface UpdateServiceSettingDto {
    appointmentReservedColor: string;
    appointmentConfirmedColor: string;
    needsPickUpColor: string;
    pickingUpVehicleColor: string;
    vehiclePickedUpColor: string;
    deliveringVehicleColor: string;
    vehicleArrivedColor: string;
    underReviewColor: string;
    waitingWarehousePricingColor: string;
    waitingManagerPricingColor: string;
    waitingConfirmationColor: string;
    waitingRepairPartsColor: string;
    waitingRepairColor: string;
    underRepairColor: string;
    waitingCompletionColor: string;
    waitingPaymentColor: string;
    needsReturningColor: string;
    returningVehicleColor: string;
    vehicleReturnedColor: string;
    finishedColor: string;
    cancelledColor: string;
    appointmentReservedEnabled: boolean;
    appointmentConfirmedEnabled: boolean;
    needsPickUpEnabled: boolean;
    pickingUpVehicleEnabled: boolean;
    vehiclePickedUpEnabled: boolean;
    deliveringVehicleEnabled: boolean;
    vehicleArrivedEnabled: boolean;
    underReviewEnabled: boolean;
    waitingWarehousePricingEnabled: boolean;
    waitingManagerPricingEnabled: boolean;
    waitingConfirmationEnabled: boolean;
    waitingRepairPartsEnabled: boolean;
    waitingRepairEnabled: boolean;
    underRepairEnabled: boolean;
    waitingCompletionEnabled: boolean;
    waitingPaymentEnabled: boolean;
    needsReturningEnabled: boolean;
    returningVehicleEnabled: boolean;
    vehicleReturnedEnabled: boolean;
    finishedEnabled: boolean;
    cancelledEnabled: boolean;
}

export interface CurrentUserDataDto {
    id: string;
    serviceId: string;
    name: string;
    eMail: string;
    type: ServiceUserType;
    picture: string;
}

export interface FaultSuggestionDto {
    name: string;
    type: FaultSuggestionType;
}

export enum FaultSuggestionType {
    Fault = 0,
    RepairPart = 1,
}

export interface ServiceUserProfileDataDto {
    id: string;
    type: ServiceUserType;
    name: string;
    phone: string;
    eMail: string;
    picture: string;
    lastLogin: Date | null;
    userName: string;
    password: string;
}

export interface FleetManagerProfileDataDto extends ServiceUserProfileDataDto {
    logo: string;
}

export interface GetFaultSuggestionsResult {
    suggestions: FaultSuggestionDto[];
}

export interface ListSettingDataDto {
    id: string;
    userManagementLayout: string;
    userGroupsLayout: string;
    appointmentsLayout: string;
    facilityTypesLayout: string;
    facilitiesLayout: string;
    appointmentWorksheetsLayout: string;
    finishedWorksheetsLayout: string;
    customersLayout: string;
    serviceCarsLayout: string;
    carsLayout: string;
    fleetCustomersLayout: string;
    servicePartnersLayout: string;
    calendarLayout: string;
    partsLayout: string;
    suppliersLayout: string;
    discountsLayout: string;
    inventoryEventsLayout: string;
}

export interface MenuInfoCountDto {
    appointmentWorksheetCount: number;
    currentWorksheetCount: number;
}

export interface ModifyServiceEmployeeDto {
    name: string;
    eMail: string;
    phone: string;
    type: ServiceUserType;
    status: ServiceUserStatus;
    mondayOpenFrom: Date | null;
    mondayOpenTo: Date | null;
    mondayBreakFrom: Date | null;
    mondayBreakTo: Date | null;
    tuesdayOpenFrom: Date | null;
    tuesdayOpenTo: Date | null;
    tuesdayBreakFrom: Date | null;
    tuesdayBreakTo: Date | null;
    wednesdayOpenFrom: Date | null;
    wednesdayOpenTo: Date | null;
    wednesdayBreakFrom: Date | null;
    wednesdayBreakTo: Date | null;
    thursdayOpenFrom: Date | null;
    thursdayOpenTo: Date | null;
    thursdayBreakFrom: Date | null;
    thursdayBreakTo: Date | null;
    fridayOpenFrom: Date | null;
    fridayOpenTo: Date | null;
    fridayBreakFrom: Date | null;
    fridayBreakTo: Date | null;
    saturdayOpenFrom: Date | null;
    saturdayOpenTo: Date | null;
    saturdayBreakFrom: Date | null;
    saturdayBreakTo: Date | null;
    sundayOpenFrom: Date | null;
    sundayOpenTo: Date | null;
    sundayBreakFrom: Date | null;
    sundayBreakTo: Date | null;
    visibleInCalendar: boolean;
    facilities: string[];
    password: string;
}

export enum ServiceUserStatus {
    Active = 0,
    Inactive = 1,
}

export interface RegisterServiceUserDto {
    type: RegisterUserType;
    serviceType: RegisterServiceType;
    name: string;
    eMail: string;
    phone: string;
    password: string;
    serviceName: string;
    serviceShortDescription: string;
    serviceDescription: string;
    serviceEMail: string;
    servicePhone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    taxNumber: string;
    mondayOpenFrom: Date | null;
    mondayOpenTo: Date | null;
    mondayBreakFrom: Date | null;
    mondayBreakTo: Date | null;
    tuesdayOpenFrom: Date | null;
    tuesdayOpenTo: Date | null;
    tuesdayBreakFrom: Date | null;
    tuesdayBreakTo: Date | null;
    wednesdayOpenFrom: Date | null;
    wednesdayOpenTo: Date | null;
    wednesdayBreakFrom: Date | null;
    wednesdayBreakTo: Date | null;
    thursdayOpenFrom: Date | null;
    thursdayOpenTo: Date | null;
    thursdayBreakFrom: Date | null;
    thursdayBreakTo: Date | null;
    fridayOpenFrom: Date | null;
    fridayOpenTo: Date | null;
    fridayBreakFrom: Date | null;
    fridayBreakTo: Date | null;
    saturdayOpenFrom: Date | null;
    saturdayOpenTo: Date | null;
    saturdayBreakFrom: Date | null;
    saturdayBreakTo: Date | null;
    sundayOpenFrom: Date | null;
    sundayOpenTo: Date | null;
    sundayBreakFrom: Date | null;
    sundayBreakTo: Date | null;
}

export enum RegisterServiceType {
    Service = 0,
    CarWash = 1,
    TireShop = 2,
    MOTTestingStation = 3,
}

export enum RegisterUserType {
    ServiceManager = 0,
    FleetManager = 1,
}

export interface ServiceEmployeeDataDto {
    id: string;
    serviceId: string;
    name: string;
    eMail: string;
    phone: string;
    lastLogin: Date | null;
    type: ServiceUserType;
    status: ServiceUserStatus;
    mondayOpenFrom: Date | null;
    mondayOpenTo: Date | null;
    mondayBreakFrom: Date | null;
    mondayBreakTo: Date | null;
    tuesdayOpenFrom: Date | null;
    tuesdayOpenTo: Date | null;
    tuesdayBreakFrom: Date | null;
    tuesdayBreakTo: Date | null;
    wednesdayOpenFrom: Date | null;
    wednesdayOpenTo: Date | null;
    wednesdayBreakFrom: Date | null;
    wednesdayBreakTo: Date | null;
    thursdayOpenFrom: Date | null;
    thursdayOpenTo: Date | null;
    thursdayBreakFrom: Date | null;
    thursdayBreakTo: Date | null;
    fridayOpenFrom: Date | null;
    fridayOpenTo: Date | null;
    fridayBreakFrom: Date | null;
    fridayBreakTo: Date | null;
    saturdayOpenFrom: Date | null;
    saturdayOpenTo: Date | null;
    saturdayBreakFrom: Date | null;
    saturdayBreakTo: Date | null;
    sundayOpenFrom: Date | null;
    sundayOpenTo: Date | null;
    sundayBreakFrom: Date | null;
    sundayBreakTo: Date | null;
    visibleInCalendar: boolean;
    picture: string;
    serviceLogo: string;
    facilities: FacilitySelectDto[];
    password: string;
}

export interface ServiceEmployeeFilter {
    searchString: string;
    name: string;
    eMail: string;
    type: ServiceUserType | null;
    status: ServiceUserStatus | null;
    visibleInCalendar: boolean | null;
}

export interface ServiceEmployeeListDto {
    id: string;
    name: string;
    eMail: string;
    phone: string;
    lastLogin: Date | null;
    type: ServiceUserType;
    status: ServiceUserStatus;
}

export interface ServiceUserNotificationFilter {
    serviceId: string | null;
}

export interface ServiceUserNotificationListDto {
    id: string;
    worksheetId: string;
    worksheetDocumentNumber: string;
    partName: string;
    partId: string;
    type: ServiceUserNotificationType;
    date: Date;
    seen: boolean;
}

export enum ServiceUserNotificationType {
    WorksheetAdded = 0,
    WorksheetCancelled = 1,
    CommentAdded = 2,
    WorksheetConfirmed = 3,
    WorksheetPaid = 4,
    PartStockMinimum = 5,
    PartMarginMinimum = 6,
}

export interface ServiceUserSettingDataDto {
    id: string;
    allowVehicleArrivedNotification: boolean;
    allowWaitingRepairNotification: boolean;
    allowCommentAddedNotification: boolean;
}

export interface UpdateServiceUserProfileDto {
    eMail: string;
    phone: string;
    picture: string;
    name: string;
    currentPassword: string;
    password: string;
}

export interface UpdateFleetManagerProfileDto extends UpdateServiceUserProfileDto {
    logo: string;
}

export interface UpdateServiceUserSettingDto {
    allowVehicleArrivedNotification: boolean;
    allowWaitingRepairNotification: boolean;
    allowCommentAddedNotification: boolean;
}

export interface WorksheetDataDto {
    id: string;
    documentNumber: string;
    status: WorksheetStatus;
    customer: CustomerSelectDto;
    serviceCar: ServiceCarSelectDto;
    mileage: number | null;
    arrivalDate: Date | null;
    completionDate: Date | null;
    deliveryRequested: boolean;
    deliveryAddress: string;
    deliveryPrice: number;
    discount: number;
    totalPrice: number;
    note: string;
    hasReview: boolean;
    hasInvoice: boolean;
    displayManagerNotification: boolean;
    unreadCommentCount: number;
    unreadServiceCommentCount: number;
    requestNewDate: boolean;
    name: string;
    eMail: string;
    phone: string;
    zipCode: number | null;
    city: string;
    streetName: string;
    streetCategory: string;
    streetNumber: string;
    addressFloor: string;
    addressDoor: string;
    make: MakeSelectDto;
    model: ModelDataDto;
    licensePlate: string;
    year: number | null;
    ccm: number | null;
    power: number | null;
    vin: string;
    fuelType: VehicleFuelType;
    engineNumber: string;
    summerTireSize: string;
    winterTireSize: string;
    registrationValidUntil: Date | null;
    registrationNumber: string;
    registrationCardNumber: string;
    statusLogs: WorksheetStatusLogDataDto[];
    appointments: AppointmentSelectDto[];
    deliveryUser: ServiceEmployeeSelectDto;
    assignedUsers: ServiceEmployeeSelectDto[];
    facilities: FacilitySelectDto[];
    facilityPrices: FacilityPriceDto[];
    faults: FaultDataDto[];
    comments: CommentDataDto[];
    appointmentsDescriptions: string[];
    promotions: PromotionDataDto[];
}

export interface WorksheetStatusLogDataDto {
    status: WorksheetStatus;
    date: Date;
}

export interface WorksheetFilter {
    searchString: string;
    documentNumber: string;
    serviceCarLicensePlate: string;
    status: WorksheetStatus | null;
    statusList: WorksheetStatus[] | null;
    completionDateFrom: Date | null;
    completionDateTo: Date | null;
    finishedDateFrom: Date | null;
    finishedDateTo: Date | null;
    totalPriceFrom: number | null;
    totalPriceTo: number | null;
    appCurrent: boolean | null;
    onlyAppointment: boolean | null;
    onlyCurrent: boolean | null;
    onlyHistory: boolean | null;
    carId: string | null;
    serviceCarId: string | null;
    assignedUserId: string | null;
    deliveryUserId: string | null;
    fleetManagerId: string | null;
    customerId: string | null;
}

export interface ServiceLoginRequest {
    eMail: string;
    password: string;
    platform: DevicePlatform;
}

export interface SuzukiExportFilter {
    dateTo: Date;
    dateFrom: Date;
    yearMin: number;
    yearMax: number;
    vinNumberGiven: boolean | null;
    serviceId: string;
}

export interface CarModelSelectDto {
    id: string;
    name: string;
}
export interface InventoryEventDataDto {
    id: string;
    receiptNumber: string;
    supplierId: string;
    supplier: SupplierSelectDto;
    eventDate: Date;
    userName: string;
    eventType: InventoryEventType;
    inventoryEventItems: InventoryEventItemDataDto[];
}

export interface InventoryEventListDto {
    id: string;
    receiptNumber: string;
    supplierId: string;
    supplier: SupplierSelectDto;
    eventDate: Date;
    userName: string;
    evetnType: InventoryEventType;
    inventoryEventItems: InventoryEventItemDataDto[];
}

export interface InventoryEventSelectDto {
    id: string;
    supplierId: string;
    eventDate: Date;
}

export interface ModifyInventoryEventDto {
    receiptNumber: string;
    supplierId: string;
    eventDate: Date;
    userName: string;
    eventType: InventoryEventType;
    inventoryEventItems: InventoryEventItemDataDto[];
}

export interface InventoryEventFilter {
    searchString: string;
    eventDate: Date | null;
}

export interface InventoryEventItemDataDto {
    id: string;
    inventoryEventId: string;
    inventoryEvent: InventoryEventDataDto;
    partId: string;
    part: PartSelectDto;
    quantityChange: number;
    price: number;
    vatId: string;
    vat: VatSelectDto;
    note: string;
    reserved: boolean;
}

export interface ModifyInventoryEventItemDto {
    inventoryEventId: string;
    partId: string;
    part: PartSelectDto;
    quantityChange: number;
    price: number;
    vatId: string;
    vat: VatSelectDto;
    note: string;
    reserved: boolean;
}

//----------------------------------------------------
export interface VatDataDto {
    id: string;
    name: string;
    percentage: number;
    isActive: boolean;
}

export interface VatListDto {
    id: string;
    name: string;
    percentage: number;
    isActive: boolean;
}

export interface VatSelectDto {
    id: string;
    name: string;
    percentage: number;
    isActive: boolean;
}

export interface ModifyVatDto {
    name: string;
    percentage: number;
    isActive: boolean;
}

export interface VatFilter {
    searchString: string;
    name: string | null;
    percentage: number | null;
}

//----------------------------------------------------
export interface PartTypeDataDto {
    id: string;
    name: string;
}

export interface CarModelDto {
    id: string;
    makeId: string;
    name: string;
    subModels: SubModelDto[];
}

export interface SubModelDto {
    id: string;
    modelId: string;
    name: string;
    fuel: VehicleFuelType;
    bodyType: BodyType;
    driveType: DriveType;
}

export enum BodyType {
    Coupe = 0,
    Hatch = 1,
    Estate = 2,
    Saloon = 3,
    Convertible = 4,
    EstateVan = 5,
    PanelVan = 6,
    MPV = 7,
    VanBasedMPV = 8,
    Pickup = 9,
    OffRoadVehicle = 10,
    ConvertibleOffRoadVehicle = 11,
    SUV = 12,
    ChassisCab = 13,
    Van = 14,
    Bus = 15,
    DumpTruck = 16,
    Hatchback = 17,
    PlatformChassis = 18,
    Targa = 19,
    SUVOpen = 20,
    Tipper = 21,
    Lorry = 22,
    SUVVan = 23,
    VanMPV = 24,
    HatchbackVan = 25,
    ClosedOffRoadVan = 26,
}

export enum DriveType {
    FrontWheelDrive = 0,
    RearWheelDrive = 1,
    AllWheelDrive = 2,
}

export interface EngineVariantDto {
    id: string;
    subModelId: string;
    name: string;
    type: string;
    ccm: number | null;
    power: number | null;
    productionFirstYear: number | null;
    productionLastYear: number | null;
}

export interface ReviewDto {
    id: string;
    serviceId: string;
    rating: number;
    description: string;
    userId: string;
    worksheetId?: string;
    createdDate?: Date;
}

export interface PromotionDataDto {
    id: string;
    title: string;
    startDate: Date;
    endDate: Date;
    discountPercentage: number;
    serviceDescription: string;
    enabled: boolean;
}
export interface PartTypeListDto {
    id: string;
    name: string;
}

export interface PartTypeSelectDto {
    id: string;
    name: string;
}

export interface ModifyPartTypeDto {
    name: string;
}

export interface PartTypeFilter {
    searchString: string;
    name: string | null;
}
//----------------------------------------------------
export interface PartGroupDataDto {
    id: string;
    name: string;
}

export interface PartGroupListDto {
    id: string;
    name: string;
}

export interface PartGroupSelectDto {
    id: string;
    name: string;
}

export interface ModifyPartGroupDto {
    name: string;
}

export interface PartGroupFilter {
    searchString: string;
    name: string | null;
}
//----------------------------------------------------
export interface PartUnitDataDto {
    id: string;
    name: string;
}

export interface PartUnitListDto {
    id: string;
    name: string;
}

export interface PartUnitSelectDto {
    id: string;
    name: string;
}

export interface ModifyPartUnitDto {
    name: string;
}

export interface PartUnitFilter {
    searchString: string;
    name: string | null;
}

//----------------------------------------------------
export interface InventoryFilter {
    searchString: string;
    partNumber: string;
    name: string;
    type: string;
    purchasePrice: number;
    retailPrice: number;
    shelfLocation: string;
    quantity: number;
}

export interface InventoryListDto {
    id: string;
    partNumber: string;
    name: string;
    type: string;
    group: string;
    purchasePrice: number;
    margin: number;
    retailPrice: number;
    shelfLocation: string;
    actualQuantity: number | null;
    reservedQuantity: number;
    quantity: number;
    netValue: number;
    grossValue: number;
    unit: string;
    note: string;
}

export interface InventoryValues {
    netValue: number;
    grossValue: number;
    retailValue: number;
}

export interface PartStockMinimumNotificationsEnabledDto {
    enabled: boolean;
}

export interface PartMarginMinimumNotificationsEnabledDto {
    enabled: boolean;
}
//--------------------------------------------------------

export function DiscountFilter(
    filterArgs: any,
    DiscountFilter: any,
    additionalArgs: any,
    ListRequestArgs: any,
) {
    throw new Error("Function not implemented.");
}
